import cx from 'clsx';
import Link from 'next/link';
import { useContext } from 'react';

import { InfoContext } from '@/context/info';
import { getInternalLink } from '@/utils/url/utm';

import styles from './styles.module.scss';
import type { Component } from './types';

export const Item: Component = ({
  isActive,
  text,
  href,
  target,
  disabled,
  allowAppendSubModelId,
}) => {
  const { selectedSubmodelId } = useContext(InfoContext);

  return (
    <li className={styles.containerRoot}>
      <Link
        aria-disabled={disabled}
        className={cx(
          styles.linkItem,
          isActive && styles.isActive,
          disabled && styles.isDisabled,
        )}
        href={`${getInternalLink(`${href}${(selectedSubmodelId && allowAppendSubModelId) ? `?submodel_id=${selectedSubmodelId}` : ''}`, 'carinfo')}`}
        prefetch={false}
        target={target}>
        {text}
      </Link>
    </li>
  );
};
